var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 48C9 26.46 26.46 9 48 9C69.54 9 87 26.46 87 48C87 69.54 69.54 87 48 87C26.46 87 9 69.54 9 48ZM48 33C48.7957 33 49.5587 33.3161 50.1213 33.8787C50.6839 34.4413 51 35.2044 51 36V51C51 51.7957 50.6839 52.5587 50.1213 53.1213C49.5587 53.6839 48.7957 54 48 54C47.2043 54 46.4413 53.6839 45.8787 53.1213C45.3161 52.5587 45 51.7957 45 51V36C45 35.2044 45.3161 34.4413 45.8787 33.8787C46.4413 33.3161 47.2043 33 48 33ZM48 66C48.7957 66 49.5587 65.6839 50.1213 65.1213C50.6839 64.5587 51 63.7957 51 63C51 62.2043 50.6839 61.4413 50.1213 60.8787C49.5587 60.3161 48.7957 60 48 60C47.2043 60 46.4413 60.3161 45.8787 60.8787C45.3161 61.4413 45 62.2043 45 63C45 63.7957 45.3161 64.5587 45.8787 65.1213C46.4413 65.6839 47.2043 66 48 66Z",
    fill: "#A33632"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11264_22482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0588 55.0487C50.0023 55.0487 51.5924 54.0512 51.6432 52.7996L52.6761 27.37C52.7288 26.0714 51.1087 25 49.0915 25H46.909C44.8878 25 43.266 26.0756 43.3248 27.3769L44.4748 52.8063C44.5313 54.0552 46.119 55.0487 48.0588 55.0487Z",
    fill: "#FCF4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 58.6768C44.6863 58.6768 42 61.2117 42 64.3385C42 67.4652 44.6863 69.9999 48 69.9999C51.3137 69.9999 54 67.4652 54 64.3385C54 61.2117 51.3137 58.6768 48 58.6768Z",
    fill: "#FCF4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11264_22482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 45,
    fill: "white",
    transform: "translate(42 25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.df2bac07c47309a407a1a8867756b645.svg";
export { ForwardRef as ReactComponent };